import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { TrxservicesAchPage } from './trxservices-ach.page';

const routes: Routes = [
  {
    path: '',
    component: TrxservicesAchPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TrxservicesAchPageRoutingModule {}
